import React from "react";
import NavBar from "./NavBar";

export const Letter = (props) => {
  return (
    <div>
      <NavBar />
      <h3 className="input">
        Dear Nathan,
        <br />
        {props.text}
        <h3 align="right">
          Sincerely,
          <br />
          Abigail
        </h3>
      </h3>
    </div>
  );
};

export default Letter;
